// Design tokens (plain JS values, portable to React Native where noted).
export const colors = {
  navy: '#0b2a5e',
  navyNight: '#071b40',
  navyTint: '#1c3a75',
  navyLine: '#1c3466',
  softBlue: '#c2cce3',
  mist: '#eef2fa',
  mistStrong: '#e4eaf6',
  pageGrey: '#f3f6fb',
  border: '#dbe2f0',
  divider: '#e8edf6',
  ink: '#0f1b33',
  slate: '#4d5970',
  teal: '#2f6f72',
  tealTint: '#e3eef0',
  danger: '#a13a3a',
  dangerStrong: '#b42318',
  dangerTint: '#fde2e2',
  footerText: '#d5ddf0',
  footerMuted: '#b9c6e6',
  overlay: 'rgba(7,27,64,0.55)',
  whatsapp: '#168a47',
  white: '#ffffff',
};

export const fontFamily = "'Outfit', system-ui, sans-serif";

export const fontSizes = {
  caption: 13,
  small: 14,
  body: 16,
  bodyLg: 17,
  h3: 20,
  h2: 30,
  section: 36,
  sectionMobile: 26,
  display: 54,
  displayMobile: 34,
  pageTitle: 38,
  pageTitleMobile: 26,
};

export const fontWeights = { regular: 400, medium: 500, semibold: 600, bold: 700 };

export const spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 48, huge: 64 };

export const radii = { input: 12, button: 14, card: 18, cardLg: 22, hero: 28, modal: 24, pill: 999 };

export const shadows = {
  card: '0 2px 6px rgba(15,27,51,0.05)',
  summary: '0 6px 20px rgba(15,27,51,0.08)',
  modal: '0 24px 60px rgba(7,27,64,0.35)',
};

export const layout = {
  containerMax: 1200,
  gutter: 24,
  gutterMobile: 16,
  headerHeight: 76,
  headerHeightMobile: 64,
  buttonHeight: 52,
  ctaHeight: 56,
  touchTarget: 44,
};

// Mirrors hooks/useMediaQuery.js
export const breakpoints = { mobileMax: 768, tabletMax: 1024, desktopMin: 1025 };

export const statusTones = {
  placed: { bg: '#fef3c7', fg: '#92400e' },
  shipped: { bg: '#dbeafe', fg: '#1e40af' },
  delivered: { bg: '#dcfce7', fg: '#166534' },
  cancelled: { bg: '#fde2e2', fg: '#a13a3a' },
  failed: { bg: '#fde2e2', fg: '#a13a3a' },
  default: { bg: '#e4eaf6', fg: '#0b2a5e' },
};

/** Orders show only Confirmed / Delivered / Cancelled; older statuses (pending, shipped, completed…) fold into these. */
export const orderStatusKey = (status) => {
  const s = String(status || '').toLowerCase();
  if (s.includes('cancel')) return 'cancelled';
  if (s.includes('deliver') || s === 'completed') return 'delivered';
  return 'confirmed';
};

export const orderStatusLabel = (status) =>
  ({ confirmed: 'Confirmed', delivered: 'Delivered', cancelled: 'Cancelled' })[orderStatusKey(status)];

export const getStatusTone = (status) => {
  const s = String(status || '').toLowerCase();
  if (s.includes('deliver') || s === 'completed') return statusTones.delivered;
  if (s.includes('ship') || s.includes('dispatch') || s.includes('transit')) return statusTones.shipped;
  if (s.includes('cancel')) return statusTones.cancelled;
  if (s.includes('fail') || s.includes('reject')) return statusTones.failed;
  if (s.includes('place') || s.includes('pending') || s.includes('confirm') || s.includes('process') || s === 'paid') return statusTones.placed;
  return statusTones.default;
};

const tokens = { colors, fontFamily, fontSizes, fontWeights, spacing, radii, shadows, layout, breakpoints, statusTones };
export default tokens;
